export default {
  "Account Management groups Change Password, Device Management and Settings. Use these tools to protect your sign-in and choose your portal language.": {
    "es": "Administración de la cuenta reúne Cambiar contraseña, Administración de dispositivos y Configuración. Estas herramientas le permiten proteger el acceso y elegir el idioma del portal.",
    "ko": "계정 관리에는 비밀번호 변경, 기기 관리, 설정이 모여 있습니다. 로그인 보안을 관리하고 포털 언어를 선택할 수 있습니다."
  },
  "Open the section to see all three options. On a phone, they are in the More menu.": {
    "es": "Abra esta sección para ver las tres opciones. En el teléfono, están en el menú Más.",
    "ko": "이 메뉴를 펼치면 세 가지 항목이 표시됩니다. 휴대폰에서는 더 보기 메뉴에서 찾을 수 있습니다."
  },
  "These account tools are separate from invoice approval and payment processing.": {
    "es": "Estas herramientas de la cuenta son independientes de la aprobación de facturas y del procesamiento de pagos.",
    "ko": "계정 설정은 청구서 승인 및 지급 처리와 별개의 기능입니다."
  },
  "Change Password replaces the password for this account. Use it if you suspect that someone else knows your password.": {
    "es": "Cambiar contraseña reemplaza la contraseña de esta cuenta. Utilice esta opción si sospecha que otra persona conoce su contraseña.",
    "ko": "비밀번호 변경에서 현재 계정의 비밀번호를 바꿀 수 있습니다. 다른 사람이 비밀번호를 알고 있다고 의심되면 변경하세요."
  },
  "Follow the password requirements and save the change. Sign in again if your current session is invalidated.": {
    "es": "Siga los requisitos de contraseña y guarde el cambio. Si se invalida la sesión actual, vuelva a iniciar sesión.",
    "ko": "표시된 비밀번호 조건을 확인한 뒤 저장하세요. 현재 세션이 만료되면 새 비밀번호로 다시 로그인하세요."
  },
  "Never send your password or an email verification code in a message.": {
    "es": "Nunca envíe su contraseña ni un código de verificación por mensaje.",
    "ko": "비밀번호나 이메일 인증코드를 메시지로 보내지 마세요."
  },
  "Device Management lists the device name, browser and Mobile or PC type for active sessions. Device names help you recognize browsers; they do not prove who is using them.": {
    "es": "Administración de dispositivos muestra el nombre del dispositivo, el navegador y el tipo Móvil o PC de las sesiones activas. Los nombres ayudan a reconocer los navegadores, pero no demuestran quién los utiliza.",
    "ko": "기기 관리에는 활성 세션의 기기명, 브라우저, 모바일 또는 PC 구분이 표시됩니다. 기기명은 브라우저를 구분하기 위한 표시이며 실제 사용자의 신원을 증명하지는 않습니다."
  },
  "Rename familiar devices. Remove an unfamiliar device to sign out its sessions while leaving other devices signed in. Removing this device signs you out too.": {
    "es": "Cambie el nombre de los dispositivos conocidos. Elimine un dispositivo desconocido para cerrar sus sesiones sin cerrar las de los demás. Eliminar el dispositivo actual también cierra su sesión.",
    "ko": "아는 기기는 알아보기 쉽게 이름을 바꾸세요. 모르는 기기를 삭제하면 해당 기기의 세션만 로그아웃됩니다. 현재 기기를 삭제하면 본인도 로그아웃됩니다."
  },
  "Existing session means the old device information was not recorded. IP addresses are not stored in this device list.": {
    "es": "Sesión existente indica que no se registró la información del dispositivo anterior. Esta lista no almacena direcciones IP.",
    "ko": "기존 세션은 과거 기기 정보가 기록되지 않은 로그인입니다. 기기 목록에는 IP 주소가 저장되지 않습니다."
  },
  "Choose English, Spanish or Korean in Settings. The language is saved to this account, so it follows you to another device without changing another account.": {
    "es": "Elija inglés, español o coreano en Configuración. El idioma se guarda en esta cuenta y se mantiene al usar otro dispositivo, sin modificar otras cuentas.",
    "ko": "설정에서 영어, 스페인어, 한국어를 선택할 수 있습니다. 언어는 현재 계정에 저장되므로 다른 기기에서도 적용되며 다른 계정에는 영향을 주지 않습니다."
  },
  "Names, service codes, uploaded documents and information you enter remain unchanged. Hover over an underlined translated term to see the English term; on a phone, tap it.": {
    "es": "Los nombres, códigos de servicio, documentos cargados y datos que usted introduce no cambian. Pase el cursor sobre un término traducido subrayado para ver el original en inglés; en el teléfono, tóquelo.",
    "ko": "이름, 서비스 코드, 업로드 문서, 직접 입력한 정보는 번역하지 않습니다. 밑줄이 있는 번역 용어에 마우스를 올리거나 휴대폰에서 누르면 영어 원문을 확인할 수 있습니다."
  },
  "In this guide, important translated terms have a double underline with the English term above them.": {
    "es": "En esta guía, los términos traducidos importantes tienen un subrayado doble y el original en inglés encima.",
    "ko": "이 안내에서는 주요 번역 용어에 이중 밑줄을 표시하고 그 위에 작은 글씨로 영어 원문을 보여 줍니다."
  },
  "Use the question-mark Guide button whenever you need a reminder. A replay asks for confirmation, so an accidental click does not start the whole guide.": {
    "es": "Use el botón Guía con el signo de interrogación cuando necesite ayuda. La repetición requiere confirmación para evitar que un clic accidental inicie toda la guía.",
    "ko": "설명이 다시 필요하면 물음표 모양의 안내 버튼을 누르세요. 다시 재생하기 전에 확인창이 표시되므로 실수로 눌러도 바로 시작되지 않습니다."
  },
  "Next continues, Skip closes the guide, and Escape also closes it. Finishing or skipping is remembered for your account across devices.": {
    "es": "Siguiente continúa, Omitir cierra la guía y Escape también la cierra. Al finalizar u omitir, la preferencia se guarda en su cuenta para todos sus dispositivos.",
    "ko": "다음을 누르면 설명이 이어지고, 건너뛰기 또는 Esc 키를 누르면 닫힙니다. 완료하거나 건너뛴 기록은 계정에 저장되어 다른 기기에서도 유지됩니다."
  },
  "The guide never submits a form or approves an invoice. To end your session, use Sign Out in the profile menu or the mobile More menu.": {
    "es": "La guía nunca envía formularios ni aprueba facturas. Para cerrar su sesión, use Cerrar sesión en el menú del perfil o en el menú Más del teléfono.",
    "ko": "안내를 진행해도 양식이 제출되거나 청구서가 승인되지 않습니다. 로그아웃하려면 프로필 메뉴 또는 휴대폰 더 보기 메뉴의 로그아웃을 이용하세요."
  },
  "This guide explains the Employee Portal tabs and the approval steps. The arrow points to the tab being described; you stay on your current page.": {
    "es": "Esta guía explica las pestañas del Portal del empleado y las etapas de aprobación. La flecha señala la pestaña que se describe, sin salir de la página actual.",
    "ko": "Employee Portal의 메뉴와 승인 절차를 설명합니다. 화살표가 설명 중인 메뉴를 가리키며 현재 페이지에서 이동하지 않습니다."
  },
  "Dashboard gives you an overview of your account. On a phone, the bottom bar opens common pages and More contains every other tab.": {
    "es": "El panel ofrece un resumen de su cuenta. En el teléfono, la barra inferior abre las páginas principales y Más contiene las demás pestañas.",
    "ko": "대시보드에서 계정 현황을 확인하세요. 휴대폰 하단에는 자주 쓰는 메뉴가 있고, 나머지는 더 보기에서 이용할 수 있습니다."
  },
  "Choose the correct client before recording work or submitting an invoice. Use Next to continue or Skip to close this guide.": {
    "es": "Elija al cliente correcto antes de registrar trabajo o presentar una factura. Use Siguiente para continuar u Omitir para cerrar esta guía.",
    "ko": "근무를 기록하거나 청구서를 제출하기 전에 올바른 클라이언트를 선택하세요. 다음을 눌러 계속하거나 건너뛰기로 안내를 닫을 수 있습니다."
  },
  "Enrollment contains your personal information, payment details, service selections, required documents and signatures. The selected employer determines which client relationship the enrollment belongs to.": {
    "es": "La inscripción contiene sus datos personales, información de pago, selección de servicios, documentos obligatorios y firmas. El empleador seleccionado determina a qué relación con un cliente pertenece la inscripción.",
    "ko": "가입 서류에서는 개인정보, 지급 정보, 서비스 선택, 필수 서류와 서명을 작성합니다. 선택한 고용주에 따라 해당 가입 서류가 연결되는 클라이언트가 정해집니다."
  },
  "Check the employer selector before saving or uploading. W-2 or 1099 classification and requirements such as Live Scan are set separately by Admin for each client relationship.": {
    "es": "Revise el empleador seleccionado antes de guardar o cargar archivos. Admin establece por separado la clasificación W-2 o 1099 y los requisitos, como Live Scan, para cada relación con un cliente.",
    "ko": "저장하거나 업로드하기 전에 고용주 선택을 확인하세요. W-2·1099 분류와 Live Scan 등의 요건은 Admin이 클라이언트 관계별로 각각 설정합니다."
  },
  "Resource Documents provides the available forms. Review any prefilled copy and complete missing answers before signing or submitting it. A document upload is not itself approval.": {
    "es": "Documentos de referencia ofrece los formularios disponibles. Revise las copias completadas automáticamente y añada las respuestas que falten antes de firmar o enviar. Cargar un documento no equivale a su aprobación.",
    "ko": "참고 서류에서 제공되는 양식을 확인하세요. 자동입력된 사본을 검토하고 빈 항목을 작성한 뒤 서명·제출하세요. 문서를 업로드했다고 해서 자동으로 승인되는 것은 아닙니다."
  },
  "Time Sheet shows recorded work and the available time-entry actions. Check the client, service code, work date and actual hours carefully.": {
    "es": "La hoja de horas muestra el trabajo registrado y las acciones disponibles para registrar tiempo. Revise con atención el cliente, código de servicio, fecha y horas efectivamente trabajadas.",
    "ko": "근무 시간표에서 기록된 근무와 시간 입력 기능을 확인합니다. 클라이언트, 서비스 코드, 근무일, 실제 근무시간을 꼼꼼히 확인하세요."
  },
  "Clock-in requires an approved employer relationship and the required enrollment steps. Recording time does not by itself approve payroll or issue payment.": {
    "es": "Marcar la entrada requiere una relación laboral aprobada y completar los pasos de inscripción obligatorios. Registrar tiempo no aprueba por sí solo la nómina ni emite un pago.",
    "ko": "출근 기록을 하려면 고용 관계가 승인되어 있고 필수 가입 절차를 완료해야 합니다. 시간을 기록하는 것만으로 급여가 승인되거나 지급되지는 않습니다."
  },
  "Use the available correction or deletion process for a mistake. Do not enter the same service again in an invoice if it was already billed through a timesheet.": {
    "es": "Si hay un error, utilice el proceso de corrección o eliminación disponible. No vuelva a facturar el mismo servicio si ya se cobró mediante una hoja de horas.",
    "ko": "잘못된 기록은 제공되는 수정·삭제 절차를 이용하세요. 시간표로 이미 청구한 동일 서비스를 청구서로 다시 제출하지 마세요."
  },
  "Invoice Sheets lets you describe services actually provided to a client. Select the client and service code, then enter the service date, hours, agreed rate and work performed.": {
    "es": "Las hojas de facturas permiten describir servicios efectivamente prestados a un cliente. Seleccione el cliente y el código de servicio, e indique la fecha, horas, tarifa acordada y trabajo realizado.",
    "ko": "청구서에서는 클라이언트에게 실제로 제공한 서비스를 청구할 수 있습니다. 클라이언트와 서비스 코드를 선택하고 서비스 날짜, 시간, 합의된 단가와 수행 업무를 입력하세요."
  },
  "Review the calculated total, supporting file and certification before submitting. Never bill the same work through both an invoice and a timesheet.": {
    "es": "Revise el total calculado, el archivo adjunto y la certificación antes de enviar. Nunca cobre el mismo trabajo mediante una factura y una hoja de horas.",
    "ko": "제출 전에 계산된 총액, 첨부파일, 확인 내용을 검토하세요. 같은 업무를 청구서와 시간표 양쪽으로 중복 청구하지 마세요."
  },
  "Your client reviews first. After client approval, BFMS Admin performs the final review and creates payroll. Watch both approval columns; submission alone is not payment.": {
    "es": "Su cliente revisa primero. Tras su aprobación, Admin de BFMS realiza la revisión final y crea la nómina. Revise ambas columnas de aprobación; presentar una factura no significa que se haya pagado.",
    "ko": "먼저 클라이언트가 검토합니다. 클라이언트 승인 후 BFMS Admin이 최종 확인하고 급여 기록을 생성합니다. 두 승인 상태를 모두 확인하세요. 제출만으로 지급이 완료되는 것은 아닙니다."
  },
  "Payroll shows payroll records available to your account. Compare the client, pay period and amounts with the work or invoice they relate to.": {
    "es": "Nómina muestra los registros de nómina disponibles en su cuenta. Compare el cliente, período y montos con el trabajo o la factura correspondiente.",
    "ko": "급여에서 현재 계정의 급여 기록을 확인합니다. 클라이언트, 급여 기간, 금액이 관련 근무 또는 청구서와 맞는지 확인하세요."
  },
  "Open the available document or payment information for more detail. A recorded or approved payroll item is separate from confirmation that funds reached your bank.": {
    "es": "Abra el documento o los datos de pago disponibles para ver los detalles. Un registro de nómina creado o aprobado no confirma por sí solo que el dinero llegó a su banco.",
    "ko": "제공되는 문서나 지급 정보를 열어 세부 내용을 확인하세요. 급여 기록의 생성·승인과 실제 은행 입금 확인은 별개입니다."
  },
  "Contact BFMS through Message Center if a period, amount or document looks incorrect.": {
    "es": "Si un período, monto o documento parece incorrecto, contacte con BFMS mediante el Centro de mensajes.",
    "ko": "기간, 금액, 문서에 문제가 있어 보이면 메시지 센터를 통해 BFMS에 문의하세요."
  },
  "Switch Client changes the client context for your Employee Portal. It does not create a new employment relationship or approve an invitation.": {
    "es": "Cambiar cliente modifica el contexto de cliente del Portal del empleado. No crea una nueva relación laboral ni aprueba una invitación.",
    "ko": "클라이언트 전환에서 Employee Portal에 표시할 클라이언트를 바꿉니다. 이 기능으로 새로운 고용 관계가 생기거나 초대가 승인되지는 않습니다."
  },
  "Choose the client you are working with and confirm the client shown on the page before entering work.": {
    "es": "Elija al cliente con quien está trabajando y confirme el cliente que aparece en la página antes de registrar trabajo.",
    "ko": "근무하는 클라이언트를 선택하고 화면에 표시된 이름을 확인한 뒤 근무를 입력하세요."
  },
  "In Enrollment and Invoice Sheets, also check the form-specific client selector. If a client is missing, ask BFMS to check the employer link.": {
    "es": "En Inscripción y Hojas de facturas, revise también el selector de cliente del formulario. Si falta un cliente, pida a BFMS que revise el vínculo con el empleador.",
    "ko": "가입 서류와 청구서에서는 각 양식 안의 클라이언트 선택도 확인하세요. 클라이언트가 목록에 없으면 BFMS에 고용 관계 확인을 요청하세요."
  },
  "This guide explains the Vendor Portal tabs. The arrow points to each tab without submitting forms, changing rates or approving an invoice.": {
    "es": "Esta guía explica las pestañas del Portal del proveedor. La flecha señala cada pestaña sin enviar formularios, cambiar tarifas ni aprobar facturas.",
    "ko": "Vendor Portal의 각 메뉴를 설명합니다. 화살표가 메뉴를 가리키며, 안내 중에 양식이 제출되거나 단가가 변경되거나 청구서가 승인되지 않습니다."
  },
  "Dashboard summarizes your account setup. On a phone, use the bottom bar for common actions and More for all other pages.": {
    "es": "El panel resume la configuración de su cuenta. En el teléfono, use la barra inferior para las acciones principales y Más para las demás páginas.",
    "ko": "대시보드에서 계정 준비 상태를 확인할 수 있습니다. 휴대폰 하단에는 자주 쓰는 메뉴가 있으며 나머지는 더 보기에서 찾을 수 있습니다."
  },
  "Keep your company and client selections accurate throughout the portal. Press Next to continue or Skip to close the guide.": {
    "es": "Mantenga correctas las selecciones de empresa y cliente en todo el portal. Pulse Siguiente para continuar u Omitir para cerrar la guía.",
    "ko": "포털을 이용할 때 회사와 클라이언트를 올바르게 선택했는지 확인하세요. 다음으로 계속하거나 건너뛰기로 닫을 수 있습니다."
  },
  "Account Information contains the company and contact details associated with this vendor account. Review them before completing forms or submitting invoices.": {
    "es": "Información de la cuenta contiene los datos de empresa y contacto asociados con esta cuenta de proveedor. Revíselos antes de completar formularios o presentar facturas.",
    "ko": "계정 정보에서 해당 Vendor 계정의 회사 및 연락처 정보를 확인합니다. 양식을 작성하거나 청구서를 제출하기 전에 정확한지 검토하세요."
  },
  "Use the legal name and contact details requested by each field. Your company name and other proper names are not translated by the language setting.": {
    "es": "Use el nombre legal y los datos de contacto solicitados en cada campo. El idioma del portal no traduce el nombre de su empresa ni otros nombres propios.",
    "ko": "각 항목에서 요구하는 법적 이름과 연락처를 입력하세요. 회사명 등 고유명사는 포털 언어를 변경해도 번역하지 않습니다."
  },
  "If an important field is locked or a client relationship is missing, ask BFMS to review it.": {
    "es": "Si un campo importante está bloqueado o falta una relación con un cliente, solicite a BFMS que la revise.",
    "ko": "중요한 항목을 수정할 수 없거나 클라이언트 관계가 누락되었다면 BFMS에 확인을 요청하세요."
  },
  "Banking Information holds the payment details for this vendor account. Check the account name and routing and account numbers before saving.": {
    "es": "Información bancaria contiene los datos de pago de esta cuenta de proveedor. Revise el titular y los números de ruta y cuenta antes de guardar.",
    "ko": "지급에 사용할 Vendor 계정의 은행 정보를 관리합니다. 저장하기 전에 예금주, 라우팅 번호, 계좌번호를 확인하세요."
  },
  "Keep every leading zero in a bank number. Attach the required bank document if the form requests one.": {
    "es": "Conserve todos los ceros iniciales de los números bancarios. Adjunte el documento bancario requerido si el formulario lo solicita.",
    "ko": "은행 번호 앞자리의 0을 빠뜨리지 마세요. 양식에서 은행 증빙을 요구하면 해당 서류를 첨부하세요."
  },
  "Saving bank information does not submit an invoice or authorize payment. Do not share bank details in ordinary messages.": {
    "es": "Guardar información bancaria no presenta una factura ni autoriza un pago. No comparta datos bancarios en mensajes comunes.",
    "ko": "은행 정보를 저장하는 것은 청구서 제출이나 지급 승인이 아닙니다. 일반 메시지에 은행 정보를 포함하지 마세요."
  },
  "Payroll & Rates shows the payment and rate information available for your linked clients. Confirm the agreed service rate rather than assuming a displayed total is a completed payment.": {
    "es": "Nómina y tarifas muestra la información de pagos y tarifas disponible para sus clientes vinculados. Confirme la tarifa acordada del servicio; un total mostrado no significa que el pago se haya completado.",
    "ko": "급여 및 단가에서 연결된 클라이언트의 지급·단가 정보를 확인합니다. 합의된 서비스 단가를 확인하고, 표시된 총액만으로 지급이 완료되었다고 판단하지 마세요."
  },
  "Review the relevant client and service information. Follow the review process shown if a change needs approval.": {
    "es": "Revise el cliente y los datos del servicio correspondientes. Si un cambio requiere aprobación, siga el proceso indicado.",
    "ko": "해당 클라이언트와 서비스 정보를 확인하세요. 변경에 승인이 필요한 경우 화면에 표시된 검토 절차를 따르세요."
  },
  "A rate question should be resolved before you submit an invoice using that rate.": {
    "es": "Resuelva cualquier duda sobre la tarifa antes de presentar una factura que la utilice.",
    "ko": "단가가 맞는지 의문이 있으면 그 단가로 청구서를 제출하기 전에 확인하세요."
  },
  "Use Invoice Sheets to submit services or purchases for the correct client. Check the service code, service dates, units, rate and calculated amount for every invoice line.": {
    "es": "Use Hojas de facturas para presentar servicios o compras del cliente correcto. Revise el código de servicio, las fechas, unidades, tarifa y monto calculado de cada línea.",
    "ko": "청구서에서 올바른 클라이언트의 서비스 또는 구매 내역을 제출합니다. 각 항목의 서비스 코드, 서비스 기간, 수량, 단가, 계산된 금액을 확인하세요."
  },
  "Attach the supporting document when appropriate. Review saved lines and the total before Submit. If a connection fails, check the invoice list before retrying to avoid duplicates.": {
    "es": "Adjunte el documento de respaldo cuando corresponda. Revise las líneas guardadas y el total antes de Enviar. Si falla la conexión, revise la lista de facturas antes de reintentar para evitar duplicados.",
    "ko": "필요한 증빙을 첨부하고 저장된 항목과 총액을 검토한 뒤 제출하세요. 연결 오류가 발생하면 중복 제출을 피하도록 재시도 전에 청구서 목록을 확인하세요."
  },
  "Review client and Admin statuses separately. Proposed edits follow the displayed approval process; an invoice being submitted does not mean it has been paid.": {
    "es": "Revise por separado los estados del cliente y de Admin. Las modificaciones propuestas siguen el proceso de aprobación indicado; presentar una factura no significa que se haya pagado.",
    "ko": "클라이언트와 Admin 상태를 각각 확인하세요. 수정 요청은 화면의 승인 절차에 따라 처리되며, 청구서를 제출했다고 해서 지급이 완료되는 것은 아닙니다."
  },
  "Enrollment helps you complete the setup and documents required for your vendor relationships. Check the client and the requirement shown before saving or uploading a file.": {
    "es": "La inscripción permite completar la configuración y los documentos necesarios para sus relaciones como proveedor. Revise el cliente y el requisito indicado antes de guardar o cargar un archivo.",
    "ko": "가입 서류에서 Vendor 관계에 필요한 등록 정보와 서류를 작성합니다. 저장하거나 파일을 올리기 전에 클라이언트와 표시된 요건을 확인하세요."
  },
  "A saved answer or uploaded file is separate from any required BFMS review. Follow the status shown on the page.": {
    "es": "Una respuesta guardada o un archivo cargado no sustituyen la revisión que BFMS pueda requerir. Siga el estado indicado en la página.",
    "ko": "답변 저장이나 파일 업로드는 필요한 BFMS 검토와 별개입니다. 화면에 표시된 처리 상태를 확인하세요."
  },
  "If the required document is unavailable or incorrect, contact BFMS rather than uploading an unrelated file.": {
    "es": "Si el documento requerido no está disponible o es incorrecto, contacte con BFMS en lugar de cargar un archivo que no corresponda.",
    "ko": "필요한 문서가 없거나 잘못된 문서가 표시되면 무관한 파일을 올리지 말고 BFMS에 문의하세요."
  },
  "Signature stores the signature associated with your vendor account. Review the name and signature preview before saving.": {
    "es": "Firma guarda la firma asociada con su cuenta de proveedor. Revise el nombre y la vista previa antes de guardar.",
    "ko": "서명에서 Vendor 계정에 사용할 서명을 저장합니다. 저장하기 전에 이름과 서명 미리보기를 확인하세요."
  },
  "Only sign for the person or company you are authorized to represent. A stored signature does not automatically approve an invoice.": {
    "es": "Firme únicamente en nombre de la persona o empresa que está autorizado a representar. Una firma guardada no aprueba automáticamente una factura.",
    "ko": "본인이 서명할 권한이 있는 개인 또는 회사의 명의로만 서명하세요. 서명을 저장해도 청구서가 자동으로 승인되지는 않습니다."
  },
  "Review each document and its signing instructions before using a signature on it.": {
    "es": "Revise cada documento y sus instrucciones antes de utilizar una firma en él.",
    "ko": "문서에 서명하기 전에는 해당 문서와 서명 안내를 먼저 검토하세요."
  },
  "Message Center sends a question to BFMS about your account, documents, invoice or payment. Use a clear subject and describe the help you need.": {
    "es": "El Centro de mensajes permite enviar a BFMS preguntas sobre su cuenta, documentos, facturas o pagos. Use un asunto claro y describa la ayuda que necesita.",
    "ko": "메시지 센터에서 계정, 서류, 청구서, 지급에 관한 질문을 BFMS에 보낼 수 있습니다. 제목을 명확히 쓰고 필요한 도움을 설명하세요."
  },
  "Include a service date or record reference when useful. Do not include passwords, verification codes or full bank numbers.": {
    "es": "Incluya la fecha del servicio o una referencia del registro si resulta útil. No incluya contraseñas, códigos de verificación ni números bancarios completos.",
    "ko": "필요하면 서비스 날짜나 기록 번호를 적어 주세요. 비밀번호, 인증코드, 전체 은행 계좌번호는 포함하지 마세요."
  },
  "A message is sent only when you use the Send action and the portal confirms the result.": {
    "es": "El mensaje solo se envía cuando utiliza Enviar y el portal confirma el resultado.",
    "ko": "보내기 버튼을 누르고 포털에서 처리 결과를 확인해야 메시지가 전송된 것입니다."
  },
  "Welcome to your Employee Portal": {
    "es": "Bienvenido a su Portal del empleado",
    "ko": "Employee Portal에 오신 것을 환영합니다"
  },
  "Replay the Employee Portal guide?": {
    "es": "¿Desea volver a ver la guía del Portal del empleado?",
    "ko": "Employee Portal 안내를 다시 볼까요?"
  },
  "EMPLOYEE PORTAL GUIDE": {
    "es": "GUÍA DEL PORTAL DEL EMPLEADO",
    "ko": "Employee Portal 사용 안내"
  },
  "Welcome to your Vendor Portal": {
    "es": "Bienvenido a su Portal del proveedor",
    "ko": "Vendor Portal에 오신 것을 환영합니다"
  },
  "Replay the Vendor Portal guide?": {
    "es": "¿Desea volver a ver la guía del Portal del proveedor?",
    "ko": "Vendor Portal 안내를 다시 볼까요?"
  },
  "VENDOR PORTAL GUIDE": {
    "es": "GUÍA DEL PORTAL DEL PROVEEDOR",
    "ko": "Vendor Portal 사용 안내"
  },
  "Files contains the vendor forms and documents available to your account. Open the correct document and check its instructions before completing or uploading it.": {
    "es": "Archivos contiene los formularios y documentos de proveedor disponibles en su cuenta. Abra el documento correcto y revise las instrucciones antes de completarlo o cargarlo.",
    "ko": "파일에는 현재 Vendor 계정에서 이용할 수 있는 양식과 문서가 있습니다. 올바른 문서를 열고 작성하거나 업로드하기 전에 안내를 확인하세요."
  },
  "Review the document title and client context. Keep copies of the files you submit.": {
    "es": "Revise el título del documento y el cliente correspondiente. Conserve copias de los archivos que presenta.",
    "ko": "문서 제목과 해당 클라이언트를 확인하세요. 제출하는 파일의 사본도 보관하세요."
  },
  "A file appearing in the portal is separate from any required review or approval. Contact BFMS if the file is missing or incorrect.": {
    "es": "Que un archivo aparezca en el portal no sustituye la revisión o aprobación que pueda requerirse. Contacte con BFMS si falta un archivo o es incorrecto.",
    "ko": "파일이 포털에 표시되는 것과 필요한 검토·승인은 별개입니다. 파일이 없거나 잘못된 경우 BFMS에 문의하세요."
  },
  "Verify your email": {
    "es": "Verifique su correo electrónico",
    "ko": "이메일 인증"
  },
  "Enter the six-digit code sent to {0}.": {
    "es": "Introduzca el código de seis dígitos enviado a {0}.",
    "ko": "{0}(으)로 보낸 6자리 인증코드를 입력하세요."
  },
  "The code expires in 10 minutes. Do not share it with anyone.": {
    "es": "El código vence en 10 minutos. No lo comparta con nadie.",
    "ko": "인증코드는 10분 후 만료됩니다. 다른 사람에게 알려 주지 마세요."
  },
  "Verification code": {
    "es": "Código de verificación",
    "ko": "인증코드"
  },
  "Verify code": {
    "es": "Verificar código",
    "ko": "코드 확인"
  },
  "Resend in {0}s": {
    "es": "Reenviar en {0} s",
    "ko": "{0}초 후 재전송"
  },
  "Resend code": {
    "es": "Reenviar código",
    "ko": "코드 재전송"
  },
  "A new verification code was sent.": {
    "es": "Se envió un nuevo código de verificación.",
    "ko": "새 인증코드를 보냈습니다."
  },
  "Could not verify the code. Check your connection and try again.": {
    "es": "No se pudo verificar el código. Revise la conexión y vuelva a intentarlo.",
    "ko": "인증코드를 확인하지 못했습니다. 연결을 확인한 뒤 다시 시도하세요."
  },
  "Could not resend the code. Please try again.": {
    "es": "No se pudo reenviar el código. Vuelva a intentarlo.",
    "ko": "코드를 다시 보내지 못했습니다. 다시 시도하세요."
  },
  "The code is incorrect or expired. Request a new code if needed.": {
    "es": "El código es incorrecto o ha vencido. Solicite otro si lo necesita.",
    "ko": "코드가 올바르지 않거나 만료되었습니다. 필요하면 새 코드를 요청하세요."
  },
  "Please wait before requesting another code.": {
    "es": "Espere antes de solicitar otro código.",
    "ko": "잠시 기다린 뒤 새 코드를 요청하세요."
  },
  "Please start sign-in again to request a code.": {
    "es": "Vuelva a iniciar el acceso para solicitar un código.",
    "ko": "코드를 요청하려면 로그인부터 다시 진행하세요."
  },
  "We could not send your verification email. Please try again shortly or contact BFMS.": {
    "es": "No pudimos enviar el correo de verificación. Inténtelo de nuevo en unos momentos o contacte con BFMS.",
    "ko": "인증 이메일을 보내지 못했습니다. 잠시 후 다시 시도하거나 BFMS에 문의하세요."
  },
  "Loading...": {
    "es": "Cargando…",
    "ko": "불러오는 중…"
  },
  "Email two-factor authentication": {
    "es": "Autenticación en dos pasos por correo electrónico",
    "ko": "이메일 2단계 인증"
  },
  "New-device email verification is not enabled for this portal yet.": {
    "es": "La verificación por correo para dispositivos nuevos aún no está habilitada en este portal.",
    "ko": "이 포털에서는 새 기기 이메일 인증이 아직 활성화되지 않았습니다."
  },
  "When enabled, sign-ins with your account password need an email code on a new device. Verified devices stay trusted.": {
    "es": "Cuando está activada, iniciar sesión con la contraseña de la cuenta en un dispositivo nuevo requiere un código por correo. Los dispositivos verificados siguen siendo de confianza.",
    "ko": "이 기능을 켜면 새 기기에서 계정 비밀번호로 로그인할 때 이메일 인증코드가 필요합니다. 인증한 기기는 신뢰 상태를 유지합니다."
  },
  "With email verification off, a correct password can sign in from a new device without an email code. Device Management still works.": {
    "es": "Si la verificación por correo está desactivada, una contraseña correcta permite acceder desde un dispositivo nuevo sin código. La administración de dispositivos sigue funcionando.",
    "ko": "이메일 인증을 끄면 새 기기에서도 올바른 비밀번호만으로 로그인할 수 있습니다. 기기 관리 기능은 계속 이용할 수 있습니다."
  },
  "Email verification is on.": {
    "es": "La verificación por correo está activada.",
    "ko": "이메일 인증이 켜져 있습니다."
  },
  "Email verification is off.": {
    "es": "La verificación por correo está desactivada.",
    "ko": "이메일 인증이 꺼져 있습니다."
  },
  "Turn off email verification": {
    "es": "Desactivar verificación por correo",
    "ko": "이메일 인증 끄기"
  },
  "Turn on email verification": {
    "es": "Activar verificación por correo",
    "ko": "이메일 인증 켜기"
  },
  "Turn off email verification?": {
    "es": "¿Desactivar la verificación por correo?",
    "ko": "이메일 인증을 끌까요?"
  },
  "Turn on email verification?": {
    "es": "¿Activar la verificación por correo?",
    "ko": "이메일 인증을 켤까요?"
  },
  "New devices will be able to sign in with the account password alone.": {
    "es": "Los dispositivos nuevos podrán acceder solo con la contraseña de la cuenta.",
    "ko": "새 기기에서 계정 비밀번호만으로 로그인할 수 있게 됩니다."
  },
  "New devices will need a verification code sent to your account email.": {
    "es": "Los dispositivos nuevos necesitarán un código enviado al correo de su cuenta.",
    "ko": "새 기기에서는 계정 이메일로 보낸 인증코드가 필요합니다."
  },
  "Security setting updated.": {
    "es": "Configuración de seguridad actualizada.",
    "ko": "보안 설정을 저장했습니다."
  },
  "Could not load your security settings. Please retry.": {
    "es": "No se pudo cargar la configuración de seguridad. Vuelva a intentarlo.",
    "ko": "보안 설정을 불러오지 못했습니다. 다시 시도하세요."
  },
  "Could not update your security setting. Please retry.": {
    "es": "No se pudo actualizar la configuración de seguridad. Vuelva a intentarlo.",
    "ko": "보안 설정을 저장하지 못했습니다. 다시 시도하세요."
  },
  "Review devices signed in to your account. Only the device name, browser and mobile/PC type are recorded. IP addresses are not stored in Device Management.": {
    "es": "Revise los dispositivos conectados a su cuenta. Solo se registran el nombre, el navegador y el tipo Móvil/PC. La administración de dispositivos no almacena direcciones IP.",
    "ko": "계정에 로그인된 기기를 확인하세요. 기기명, 브라우저, 모바일·PC 구분만 기록하며 기기 관리에는 IP 주소를 저장하지 않습니다."
  },
  "Remove a device to sign out its active sessions. Someone with your password can sign in again; change your password if you do not recognize a device.": {
    "es": "Elimine un dispositivo para cerrar sus sesiones activas. Quien conozca su contraseña puede volver a iniciar sesión; cambie la contraseña si no reconoce un dispositivo.",
    "ko": "기기를 삭제하면 해당 기기의 활성 세션이 로그아웃됩니다. 비밀번호를 아는 사람은 다시 로그인할 수 있으므로, 모르는 기기가 보이면 비밀번호도 변경하세요."
  },
  "This master-key session is excluded from the device list. You can manage the account's other devices here.": {
    "es": "Esta sesión con clave maestra no aparece en la lista. Aquí puede administrar los demás dispositivos de la cuenta.",
    "ko": "이 마스터키 세션은 기기 목록에 기록되지 않습니다. 여기에서 계정의 다른 기기를 관리할 수 있습니다."
  },
  "Loading devices…": {
    "es": "Cargando dispositivos…",
    "ko": "기기를 불러오는 중…"
  },
  "No active devices to display.": {
    "es": "No hay dispositivos activos que mostrar.",
    "ko": "표시할 활성 기기가 없습니다."
  },
  "This device": {
    "es": "Este dispositivo",
    "ko": "현재 기기"
  },
  "Device information was not recorded for this older session. Removing it signs out any browsers sharing that session.": {
    "es": "No se registró información del dispositivo para esta sesión anterior. Eliminarla cierra los navegadores que comparten la sesión.",
    "ko": "과거 세션에는 기기 정보가 기록되지 않았습니다. 이 세션을 삭제하면 해당 세션을 공유하는 브라우저가 함께 로그아웃됩니다."
  },
  "Device name": {
    "es": "Nombre del dispositivo",
    "ko": "기기명"
  },
  "Device name saved.": {
    "es": "Nombre del dispositivo guardado.",
    "ko": "기기 이름을 저장했습니다."
  },
  "Device removed.": {
    "es": "Dispositivo eliminado.",
    "ko": "기기를 삭제했습니다."
  },
  "Sign out this device?": {
    "es": "¿Cerrar la sesión de este dispositivo?",
    "ko": "현재 기기를 로그아웃할까요?"
  },
  "Remove this device?": {
    "es": "¿Eliminar este dispositivo?",
    "ko": "이 기기를 삭제할까요?"
  },
  "Its active sessions will be signed out.": {
    "es": "Se cerrarán sus sesiones activas.",
    "ko": "해당 기기의 활성 세션이 로그아웃됩니다."
  },
  "Remove device": {
    "es": "Eliminar dispositivo",
    "ko": "기기 삭제"
  },
  "Could not update the device list. Check your connection and refresh.": {
    "es": "No se pudo actualizar la lista. Revise la conexión y actualice la página.",
    "ko": "기기 목록을 갱신하지 못했습니다. 연결을 확인하고 새로 고침하세요."
  },
  "Enter a device name between 1 and 80 characters.": {
    "es": "Introduzca un nombre de dispositivo de entre 1 y 80 caracteres.",
    "ko": "기기 이름을 1~80자로 입력하세요."
  },
  "Browser": {
    "es": "Navegador",
    "ko": "브라우저"
  },
  "Type": {
    "es": "Tipo",
    "ko": "유형"
  },
  "Mobile": {
    "es": "Móvil",
    "ko": "모바일"
  },
  "PC": {
    "es": "PC",
    "ko": "PC"
  },
  "Unknown": {
    "es": "Desconocido",
    "ko": "알 수 없음"
  },
  "Contractor Service Details": {
    "es": "Detalles del servicio del contratista",
    "ko": "독립계약자 서비스 정보"
  },
  "Service Start Date": {
    "es": "Fecha de inicio del servicio",
    "ko": "서비스 시작일"
  },
  "Agreed Hourly Service Rate": {
    "es": "Tarifa por hora acordada",
    "ko": "합의된 시간당 서비스 단가"
  },
  "Service Description": {
    "es": "Descripción del servicio",
    "ko": "서비스 내용"
  },
  "For this 1099 relationship, submit your W-9 and signed service agreement under Required Documents. Employee W-4, DE 4 and I-9 forms are not part of this contractor workflow. Service credentials and Live Scan requirements are decided separately.": {
    "es": "Para esta relación 1099, presente el W-9 y el contrato de servicios firmado en Documentos obligatorios. Los formularios de empleados W-4, DE 4 e I-9 no forman parte de este proceso de contratista. Las credenciales y Live Scan se determinan por separado.",
    "ko": "이 1099 관계에서는 필수 서류에 W-9과 서명한 서비스 계약서를 제출하세요. 직원용 W-4, DE 4, I-9은 이 독립계약자 절차에 포함되지 않습니다. 서비스 자격과 Live Scan 요건은 별도로 결정됩니다."
  },
  "Lives with Client?": {
    "es": "¿Vive con el cliente?",
    "ko": "클라이언트와 함께 거주하나요?"
  },
  "Official blank form and instructions": {
    "es": "Formulario oficial en blanco e instrucciones",
    "ko": "공식 빈 양식 및 작성 안내"
  },
  "Select Auto-fill to prepare the original PDF for this employer. Review every page, complete missing answers, then sign and upload the completed copy under Required Documents. This does not submit or approve a document.": {
    "es": "Seleccione Autocompletar para preparar el PDF original para este empleador. Revise todas las páginas, complete lo que falte, firme y cargue la copia en Documentos obligatorios. Esta acción no envía ni aprueba un documento.",
    "ko": "자동입력을 선택하면 해당 고용주용 원본 PDF를 준비합니다. 모든 페이지를 검토하고 빈 항목을 작성한 뒤 서명하여 필수 서류에 업로드하세요. 자동입력만으로 서류가 제출되거나 승인되지는 않습니다."
  },
  "Select an enrollment employer first.": {
    "es": "Seleccione primero un empleador para la inscripción.",
    "ko": "먼저 가입 서류의 고용주를 선택하세요."
  },
  "Loading official forms...": {
    "es": "Cargando formularios oficiales…",
    "ko": "공식 양식을 불러오는 중…"
  },
  "Blank original": {
    "es": "Original en blanco",
    "ko": "빈 원본"
  },
  "Review and sign": {
    "es": "Revisar y firmar",
    "ko": "검토 및 서명"
  },
  "On a phone, download the PDF if the preview is unavailable. Save your completed copy before closing.": {
    "es": "En el teléfono, descargue el PDF si no aparece la vista previa. Guarde la copia completada antes de cerrar.",
    "ko": "휴대폰에서 미리보기가 보이지 않으면 PDF를 다운로드하세요. 닫기 전에 작성한 사본을 저장하세요."
  },
  "Classification and document requirements are confirmed by BFMS for this client. Contact BFMS if they need correction.": {
    "es": "BFMS confirma la clasificación y los documentos requeridos para este cliente. Contacte con BFMS si necesitan corregirse.",
    "ko": "해당 클라이언트의 분류와 서류 요건은 BFMS가 확인합니다. 수정이 필요하면 BFMS에 문의하세요."
  },
  "Live Scan is not required for this relationship, as determined by Admin.": {
    "es": "Admin ha determinado que esta relación no requiere Live Scan.",
    "ko": "Admin의 판단에 따라 이 관계에는 Live Scan이 필요하지 않습니다."
  },
  "Live Scan:": {
    "es": "Live Scan:",
    "ko": "Live Scan:"
  },
  "Section": {
    "es": "Sección",
    "ko": "항목"
  },
  "Use Resource Documents to prefill the official PDF with your saved information. Review all pages, complete any missing answers, sign, and upload the completed copy under Required Documents. A prefilled draft or saved portal signature does not complete a government form.": {
    "es": "Use Documentos de referencia para rellenar el PDF oficial con sus datos guardados. Revise todas las páginas, complete lo que falte, firme y cargue la copia en Documentos obligatorios. Un borrador rellenado o una firma guardada en el portal no completan un formulario gubernamental.",
    "ko": "참고 서류에서 저장된 정보로 공식 PDF를 자동입력할 수 있습니다. 모든 페이지를 검토하고 빈 항목을 작성한 뒤 서명하여 필수 서류에 업로드하세요. 자동입력 초안이나 포털에 저장된 서명만으로 정부 양식이 완성되지는 않습니다."
  },
  "Required document rule": {
    "es": "Regla de documentos obligatorios",
    "ko": "필수 서류 제출 기준"
  },
  "Upload either": {
    "es": "Cargue una de estas opciones",
    "ko": "다음 중 한 가지 방식으로 업로드하세요"
  },
  "one List A document": {
    "es": "un documento de la Lista A",
    "ko": "List A 서류 1개"
  },
  "OR": {
    "es": "O",
    "ko": "또는"
  },
  "one List B document + one List C document": {
    "es": "un documento de la Lista B y uno de la Lista C",
    "ko": "List B 서류 1개와 List C 서류 1개"
  },
  "Option 1: List A*": {
    "es": "Opción 1: Lista A*",
    "ko": "선택 1: List A*"
  },
  "or": {
    "es": "o",
    "ko": "또는"
  },
  "Option 2: List B + List C*": {
    "es": "Opción 2: Lista B + Lista C*",
    "ko": "선택 2: List B + List C*"
  },
  "Document 1": {
    "es": "Documento 1",
    "ko": "서류 1"
  },
  "Start by choosing either a List A document, or the first part of a List B + C pair.": {
    "es": "Comience seleccionando un documento de la Lista A o el primero de una combinación de las Listas B y C.",
    "ko": "List A 서류 또는 List B·C 조합의 첫 번째 서류를 선택하세요."
  },
  "Document Type": {
    "es": "Tipo de documento",
    "ko": "서류 종류"
  },
  "-- Select Document Type --": {
    "es": "-- Seleccione el tipo de documento --",
    "ko": "-- 서류 종류 선택 --"
  },
  "U.S. Passport / Passport Card": {
    "es": "Pasaporte o tarjeta de pasaporte de EE. UU.",
    "ko": "미국 여권 / 여권 카드"
  },
  "Permanent Resident Card": {
    "es": "Tarjeta de residente permanente",
    "ko": "영주권 카드"
  },
  "Foreign Passport with I-551": {
    "es": "Pasaporte extranjero con I-551",
    "ko": "I-551이 있는 외국 여권"
  },
  "Employment Authorization Document": {
    "es": "Documento de autorización de empleo",
    "ko": "취업허가서"
  },
  "FSM/RMI Passport with I-94": {
    "es": "Pasaporte de FSM/RMI con I-94",
    "ko": "I-94가 있는 FSM/RMI 여권"
  },
  "Driver’s License / State ID": {
    "es": "Licencia de conducir o identificación estatal",
    "ko": "운전면허증 / 주정부 신분증"
  },
  "School ID Card": {
    "es": "Identificación escolar",
    "ko": "학생증"
  },
  "Voter Registration Card": {
    "es": "Tarjeta de registro electoral",
    "ko": "유권자 등록증"
  },
  "U.S. Military Card": {
    "es": "Identificación militar de EE. UU.",
    "ko": "미국 군인 신분증"
  },
  "Military Dependent ID": {
    "es": "Identificación de dependiente militar",
    "ko": "군인 가족 신분증"
  },
  "Merchant Mariner Card": {
    "es": "Credencial de marino mercante",
    "ko": "상선 선원 증명서"
  },
  "Native American Tribal Document": {
    "es": "Documento de una tribu indígena de EE. UU.",
    "ko": "미국 원주민 부족 발급 서류"
  },
  "Certification of Birth Abroad": {
    "es": "Certificación de nacimiento en el extranjero",
    "ko": "해외 출생 증명서"
  },
  "Birth Certificate": {
    "es": "Certificado de nacimiento",
    "ko": "출생증명서"
  },
  "U.S. Citizen ID Card": {
    "es": "Tarjeta de identificación de ciudadano de EE. UU.",
    "ko": "미국 시민 신분증"
  },
  "Resident Citizen ID": {
    "es": "Identificación de ciudadano residente",
    "ko": "거주 시민 신분증"
  },
  "DHS Employment Auth Doc": {
    "es": "Documento de autorización de empleo del DHS",
    "ko": "DHS 취업허가 서류"
  },
  "Document Number": {
    "es": "Número del documento",
    "ko": "서류 번호"
  },
  "Issuing Authority": {
    "es": "Autoridad emisora",
    "ko": "발급 기관"
  },
  "Expiry Date (if any)": {
    "es": "Fecha de vencimiento, si corresponde",
    "ko": "만료일(해당하는 경우)"
  },
  "View Document": {
    "es": "Ver documento",
    "ko": "문서 보기"
  },
  "Document 2 (Required)": {
    "es": "Documento 2 (obligatorio)",
    "ko": "서류 2(필수)"
  },
  "-- Select Required Matching Document --": {
    "es": "-- Seleccione el documento complementario obligatorio --",
    "ko": "-- 필요한 짝 서류 선택 --"
  },
  "BFMS confirms W-2 or 1099 classification separately for each client after registration. Your enrollment forms will reflect that decision; creating this account does not select your worker classification.": {
    "es": "Después del registro, BFMS confirma la clasificación W-2 o 1099 por separado para cada cliente. Los formularios reflejarán esa decisión; crear la cuenta no determina su clasificación.",
    "ko": "가입 후 BFMS가 클라이언트별 W-2·1099 분류를 확인합니다. 가입 서류에는 그 결정이 반영되며, 계정을 만드는 것만으로 근로 분류가 정해지지는 않습니다."
  },
  "Prepare an unsigned draft of the official W-9 using your saved information. Review all six pages, complete the remaining choices, then sign and date the form yourself.": {
    "es": "Prepare un borrador sin firmar del W-9 oficial con sus datos guardados. Revise las seis páginas, complete las opciones restantes y firme y feche el formulario usted mismo.",
    "ko": "저장된 정보로 공식 W-9의 미서명 초안을 준비합니다. 6페이지 전체를 검토하고 남은 항목을 작성한 뒤 직접 서명과 날짜를 기재하세요."
  },
  "Taxpayer name for this draft": {
    "es": "Nombre del contribuyente para este borrador",
    "ko": "이 초안의 납세자 이름"
  },
  "Complete taxpayer name manually": {
    "es": "Introducir manualmente el nombre del contribuyente",
    "ko": "납세자 이름 직접 작성"
  },
  "Use my saved business name": {
    "es": "Usar el nombre comercial guardado",
    "ko": "저장된 사업체 이름 사용"
  },
  "Use my saved personal name": {
    "es": "Usar mi nombre personal guardado",
    "ko": "저장된 개인 이름 사용"
  },
  "Saved TIN type for this draft": {
    "es": "Tipo de TIN guardado para este borrador",
    "ko": "이 초안에 사용할 저장된 TIN 종류"
  },
  "Complete TIN manually": {
    "es": "Introducir el TIN manualmente",
    "ko": "TIN 직접 작성"
  },
  "These choices apply only to this draft. They do not change your account or determine your tax classification. No tax classification, signature or signing date is selected automatically.": {
    "es": "Estas opciones solo se aplican a este borrador. No modifican su cuenta ni determinan su clasificación fiscal. No se seleccionan automáticamente la clasificación fiscal, la firma ni la fecha.",
    "ko": "이 선택은 현재 초안에만 적용됩니다. 계정 정보를 변경하거나 세무 분류를 결정하지 않습니다. 세무 분류, 서명, 서명 날짜는 자동으로 선택하지 않습니다."
  },
  "Preparing official W-9...": {
    "es": "Preparando el W-9 oficial…",
    "ko": "공식 W-9을 준비하는 중…"
  },
  "Prepare draft": {
    "es": "Preparar borrador",
    "ko": "초안 준비"
  },
  "On mobile, use Download PDF if the preview is unavailable. Save your completed copy before closing.": {
    "es": "En el teléfono, use Descargar PDF si no aparece la vista previa. Guarde la copia completada antes de cerrar.",
    "ko": "휴대폰에서 미리보기가 보이지 않으면 PDF 다운로드를 이용하세요. 닫기 전에 작성한 사본을 저장하세요."
  },
  "Your session changed. Restart verification.": {
    "es": "Su sesión ha cambiado. Reinicie la verificación.",
    "ko": "로그인 세션이 변경되었습니다. 인증을 다시 시작하세요."
  }
};
